"use client";

import CWFButton from "@/components/ui/CWFButton";
import {Card, CardContent} from "@/components/ui/card";
import React, {useState} from "react";
import {FaCheck, FaMinus, FaPlus, FaTimes} from "react-icons/fa";
import PaymentSubscriptionButton from "@/app/tarifs/_components/PaymentSubscriptionButton";


export default function MobilePricingCard({name, price,datas, type,availablePlans}){
    const [showMore, setShowMore] = useState(false);

    // Fonction pour trier les features
    const sortFeatures = (features) => {
        return [...features].sort((a, b) => {
            const valueA = a[type];
            const valueB = b[type];

            // true (check) = 0, string (texte) = 1, false (times) = 2
            const getPriority = (value) => {
                if (value === true) return 0;
                if (typeof value === 'string') return 1;
                if (value === false) return 2;
                return 3;
            };

            return getPriority(valueA) - getPriority(valueB);
        });
    };

    return (
        <Card>
            <CardContent className="p-5">
                <h3 className={"font-semibold pb-2"}>Forfait {name}</h3>
                {!showMore && (
                    <button
                        className={"flex items-center gap-x-2 text-cwfLanding"}
                        onClick={() => setShowMore(!showMore)}
                    >
                        <FaPlus/> Voir plus
                    </button>
                )}


                {showMore && (
                    <div>
                        <p className={"text-2xl pb-5"}>{price !== "Gratuit" ? price + "€ TTC/mois" : "Gratuit"}</p>
                        {datas && datas.categories.map(function (data, index) {
                            const sortedFeatures = sortFeatures(data.features);

                            return(
                                <div className={"py-5"} key={index}>
                                    <p className={"text-lg font-medium"}>{data.name}</p>
                                    <ul className={"text-sm"}>
                                        {sortedFeatures.map(function (feature, index) {
                                            const featureValue = feature[type];

                                            return(
                                                <li className={"flex gap-x-2 items-center"} key={index}>
                                                    {
                                                        typeof featureValue === 'boolean'
                                                            ? featureValue
                                                                ? <FaCheck className={`text-green-500 `}/>
                                                                : <FaTimes className={"text-red-500"}/>
                                                            : <span className={"italic"}>({featureValue})</span>
                                                    }
                                                    {feature.name}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            )
                        })}

                        <div className={"pb-5"}>
                            {type === 'freemium' &&(
                                <></>
                            )}
                            {type === 'starter' && (
                                <PaymentSubscriptionButton label={"Choisir"} priceId={availablePlans.find(el => el.slug === 'cwf-starter')?.stripe_price_id} className={""}/>
                            )}

                            {type === 'expert' &&(
                                <PaymentSubscriptionButton label={"Choisir"} priceId={availablePlans.find(el => el.slug === 'cwf-expert')?.stripe_price_id} className={""}/>
                            )}

                        </div>
                        <button
                            className={"flex items-center gap-x-2 text-cwfLanding"}
                            onClick={() => setShowMore(!showMore)}
                        >
                            <FaMinus/> Voir moins
                        </button>
                    </div>
                )}
            </CardContent>
        </Card>
    )
}